import React from 'react';

import { CircularProgress } from '@mui/material';

import { CONTROLLER_ON, WHITE } from '../../constants/colors';
import { ICON_SIZE_PX } from '../../constants/styledButton';
import { IStyledButtonProps } from '../../interfaces/global';

import './styles.scss';

const customStyles = {
  customLoadingWhite: {
    color: WHITE
  },
  customLoadingBlack: {
    color: CONTROLLER_ON
  }
};

const StyledButton = ({
  loading,
  buttonType,
  buttonSize = 'sm',
  action,
  disabled,
  classes,
  children,
  image
}: React.PropsWithChildren<IStyledButtonProps>) => {
  const classNames = ['custom-button', buttonType, buttonSize, loading ? 'loading' : '', classes].join(' ');

  const spinnerStyle = {
    primary: customStyles.customLoadingWhite,
    secondary: customStyles.customLoadingBlack,
    tertiary: customStyles.customLoadingBlack,
    'primary-inverse': customStyles.customLoadingBlack,
    'secondary-inverse': customStyles.customLoadingWhite,
    'tertiary-inverse': customStyles.customLoadingWhite,
    'primary-green': customStyles.customLoadingBlack
  };

  const renderContent = () => {
    if (image) {
      if (image.position === 'left') {
        return (
          <>
            <image.component className="styled-btn-icon left" datatest-id="image-left" />
            {children}
          </>
        );
      }
      return (
        <>
          {children}
          <image.component className="styled-btn-icon right" datatest-id="image-right" />
        </>
      );
    }
    return children;
  };

  return (
    <button disabled={loading || disabled} className={classNames} onClick={action}>
      {loading && <CircularProgress sx={{ ...spinnerStyle[buttonType] }} size={ICON_SIZE_PX[buttonSize]} />}
      {!loading && renderContent()}
    </button>
  );
};

export default StyledButton;
